import BaseObjectDirective from './BaseObjectDirective';
import Countable from 'countable';
/**
 * AsfResponseTextBoxObjectCtrl is a controller class for handling the behavior of a text box object in a response.
 * It extends the BaseObjectDirective and provides functionality for initializing preferences, updating registered names,
 * recalculating minimum height, and managing word count.
 */
class AsfResponseTextBoxObjectCtrl extends BaseObjectDirective {
    /**
     * Constructor for AsfResponseTextBoxObjectCtrl.
     * @param {Object} $injector - AngularJS injector service.
     * @param {Object} $scope - AngularJS scope service.
     * @param {Object} $rootScope - AngularJS root scope service.
     * @param {Object} $signals - Signals service.
     * @param {Object} $timeout - AngularJS timeout service.
     * @param {Object} SheetLoadedService - Service for handling sheet loading.
     * @param {Object} $q - AngularJS promise service.
     * @param {Object} $bridges - Bridges service.
     * @param {Object} $translate - AngularJS translate service.
     */
    constructor($injector, $scope, $rootScope, $signals, $timeout, SheetLoadedService, $q, $bridges, $translate) {
        super($injector, $scope);

        this.registerObjectInstance('text');

        $scope.isCMS = $rootScope.isCMS && !$rootScope.isPreview;
        $scope.isPreview = $rootScope.isPreview;
        $scope.editMode = false;
        $scope.prefsMode = false;
        $scope.wordcount = 0;

        this._tmp = $scope.resetChanges;
        this.t = this;
        this.heightOptions = ['small', 'medium', 'large'];
        this.heightOptionToPixels = {
            'small': 150,
            'medium': 300,
            'large': 450
        };

        $scope.resetChanges = () => {
            this._tmp();
            this.t.injections.$scope.initPreferences();
        };

        $scope.areaId = $scope.contentObject.getUUID() + "_textarea";

        $scope.initPreferences = () => {
            let height = (typeof $scope.contentObject.getPreferences() != "undefined" ? $scope.contentObject.getPreferences().height : null);
            let placeholder = (typeof $scope.contentObject.getPreferences() != "undefined" ? $scope.contentObject.getPreferences().placeholder : null);
            let autogrow = (typeof $scope.contentObject.getPreferences() != "undefined" ? $scope.contentObject.getPreferences().autogrow : null);
            let wordcount = (typeof $scope.contentObject.getPreferences() != "undefined" ? $scope.contentObject.getPreferences().wordcount : true);
            let richtext = (typeof $scope.contentObject.getPreferences() != "undefined" ? $scope.contentObject.getPreferences().richtext : null);
            let objName = (typeof $scope.contentObject.getPreferences() != "undefined" ? $scope.contentObject.getPreferences().objName : undefined);
            let includedInPDF = (typeof $scope.contentObject.getPreferences() !== "undefined" ? $scope.contentObject.getPreferences().includedInPDF : true);
            let specialChars = (typeof $scope.contentObject.getPreferences() !== "undefined" ? $scope.contentObject.getPreferences().specialChars : null);

            let TaskInfoService = $injector.get('TaskInfoService'),
                taskInfo = TaskInfoService.getTaskInfo();
            let assessmentLanguage = taskInfo.getLanguageCode();

            let languages = ['English', 'Français', 'Español', 'Deutsch', 'Nederlands'],
                lang_codes = ['en', 'fr', 'es', 'de', 'nl'];
            let spellchecker_language;

            if (typeof $scope.contentObject.getPreferences() != "undefined" && $scope.contentObject.getPreferences().spellchecker_language != null) {
                spellchecker_language = $scope.contentObject.getPreferences().spellchecker_language;
            } else {
                spellchecker_language = languages[lang_codes.indexOf(assessmentLanguage)];
            }
            if (taskInfo.isInputLanguageCode()) {
                spellchecker_language = languages[lang_codes.indexOf(taskInfo.getSpellcheckerLanguageCode())];
                $scope.langISO = $rootScope.isJournal ? $translate.preferredLanguage() : taskInfo.getISOInputLanguageCode();
            }
            $scope.writingDirection = $rootScope.isJournal ? "ltr" : taskInfo.getInputLanguage().writingDirection;

            let spellchecker_is_enabled = (typeof $scope.contentObject.getPreferences() != "undefined" ? $scope.contentObject.getPreferences().spellchecker_is_enabled : null);
            let spellchecker_language_defined = angular.isString(spellchecker_language) && spellchecker_language !== "" && spellchecker_language !== null;
            if ((typeof spellchecker_is_enabled == 'undefined' || spellchecker_is_enabled === null) && spellchecker_language_defined) {
                spellchecker_is_enabled = false;
            }

            $scope.disabledCheckbox = {
                spellchecker_is_enabled: richtext === false ? true : false,
                spellchecker_language: richtext === false ? true : false
            };

            $scope.$watch('preferencesValues', (val1, val2) => {
                if (val1 == val2)
                    return;
                let preferences = {};
                angular.forEach($scope.preferencesValues, (value, key) => {
                    preferences[key] = value;
                });
                if (!val2.richtext) {
                    //console.log($scope.preferences['02-other'][6].name = "hurrrrr");
                }
                let cke = CKEDITOR.instances['cke-' + $scope.contentObject.getUUID()];
                let richtextChanged = false;
                if ((val1.spellchecker_is_enabled != val2.spellchecker_is_enabled || val1.spellchecker_language != val2.spellchecker_language) && cke) {
                    cke.changePreferences(preferences);
                }
                $scope.contentObject.setPreferences(preferences);
                $scope.startNonRichTextWordCount();
                $scope.recalcMinHeight();
                $scope.updateRegisteredName();
                if (preferences.spellchecker_is_enabled && preferences.richtext && cke && !richtextChanged) {
                    window.setTimeout(() => {
                        cke.ext = true;
                        walk(cke.document.$, cke.document.$.body, cke.window.$, cke);
                        cke.ext = false;
                    }, 0.1);
                }
                if ($scope.preferencesValues['richtext'] === false) {
                    $timeout(() => {
                        $scope.$apply(() => {
                            $scope.preferencesValues['spellchecker_is_enabled'] = false;
                            $scope.disabledCheckbox['spellchecker_is_enabled'] = true;
                            $scope.disabledCheckbox['spellchecker_language'] = true;
                        });
                    }, 1);
                } else if ($scope.preferencesValues['richtext'] === true) {
                    $timeout(() => {
                        $scope.$apply(() => {
                            $scope.disabledCheckbox['spellchecker_is_enabled'] = false;
                            $scope.disabledCheckbox['spellchecker_language'] = false;
                        });
                    }, 1);
                }
            }, true);

            $scope.preferencesValues = {};
            $scope.preferencesValues['height'] = height;
            $scope.preferencesValues['placeholder'] = placeholder;
            $scope.preferencesValues['autogrow'] = autogrow;
            $scope.preferencesValues['wordcount'] = wordcount;
            $scope.preferencesValues['richtext'] = richtext;
            $scope.preferencesValues['objName'] = objName;
            $scope.preferencesValues['includedInPDF'] = typeof includedInPDF !== 'undefined' ? includedInPDF : true;
            $scope.preferencesValues['specialChars'] = typeof specialChars !== 'undefined' ? specialChars : null;
            $scope.preferencesValues['spellchecker_language'] = spellchecker_language;
            $scope.preferencesValues['spellchecker_is_enabled'] = spellchecker_is_enabled;

            $scope.preferences = [
                {
                    '01-placeholder': [
                        {'type': 'textarea', 'name': 'Placeholder text', 'valueKey': 'placeholder'}
                    ],
                    '02-other': [
                        {'type': 'checkbox', 'name': 'Included in Response PDF', 'valueKey': 'includedInPDF'},
                        {'type': 'checkbox', 'name': 'Auto-grow?', 'valueKey': 'autogrow'},
                        {'type': 'checkbox', 'name': 'Word count?', 'valueKey': 'wordcount'},
                        {'type': 'checkbox', 'name': 'Rich text?', 'valueKey': 'richtext', 'enabled': false},
                        {'type': 'input', 'name': 'Object Name', 'valueKey': 'objName'},
                        {'type': 'select', 'name': 'Initial Height', 'valueKey': 'height', options: this.heightOptions, 'noDummyOption': true},
                        {'type': 'checkbox', 'name': 'Enable spellchecker?', 'valueKey': 'spellchecker_is_enabled'},
                        {'type': (taskInfo.isInputLanguageCode() ? 'input' : 'select'), 'name': 'Language:', 'options': languages, 'valueKey': 'spellchecker_language', 'disabled': (taskInfo.isInputLanguageCode() ? true : false)}
                    ]
                },
            ];
        };

        $scope.updateRegisteredName = () => {
            let preferences = $scope.contentObject.getPreferences();
            if (!angular.isDefined(preferences.objName)) {
                return;
            }
            this.registerObjectInstanceWithName(preferences.objName);
        };

        $scope.minHeightCSS = '150px!important';
        $scope.minHeight = 150;
        $scope.recalcMinHeight = () => {
            let height = $scope.preferencesValues['height'];
            if (!angular.isDefined(height) || height === null) {
                $scope.minHeight = this.heightOptionToPixels['small'];
            } else {
                $scope.minHeight = this.heightOptionToPixels[height];
            }
            $scope.minHeightCSS = $scope.minHeight + "px!important";
        };

        $scope.wordCount = 0;
        $scope.wordCountArea = false;

        $scope.startNonRichTextWordCount = () => {
            if ($scope.preferencesValues['richtext']) {
                return;
            }
            
            $timeout(() => {
                $scope.wordCountArea = document.getElementById($scope.areaId);
                if ($scope.wordCountArea && $scope.preferencesValues['wordcount']) {
                    // Add input event listener to count words on changes
                    $scope.wordCountArea.addEventListener('input', () => {
                        Countable.count($scope.wordCountArea, counter => {
                            $scope.$apply(() => {
                                $scope.wordCount = counter.words;
                            });
                        });
                    });
                    
                    // Initial count
                    Countable.count($scope.wordCountArea, counter => {
                        $scope.$apply(() => {
                            $scope.wordCount = counter.words;
                        });
                    });
                }
            });
        };

        $scope.$on('$destroy', () => {
            if ($scope.wordCountArea) {
                // Remove event listener on destroy
                $scope.wordCountArea.removeEventListener('input');
            }
            $('iframe').contents().find('html').off('click', this.clickOutsideForIframes);
            $('iframe').contents().find('#svgroot').off('click', this.clickOutsideForIframes);
        });

        $scope.onEditorCallback = (e) => {
            /*var ckEditor = CKEDITOR.instances['cke-'+$scope.contentObject.getUUID()];
            var data = ckEditor.getData();*/
        };

        this.appendText = (txt) => {
            if ($scope.preferencesValues['richtext']) {
                let ckEditor = CKEDITOR.instances['cke-' + $scope.contentObject.getUUID()];
                let range = ckEditor.createRange();
                range.moveToPosition(range.root, CKEDITOR.POSITION_BEFORE_END);
                ckEditor.getSelection().selectRanges([range]);
                ckEditor.insertHtml(txt);
            } else {
                let area = $("#" + $scope.areaId);
                area.val(area.val() + txt);
            }
        };

        $scope.initPreferences();
        $scope.startNonRichTextWordCount();
        $scope.recalcMinHeight();
        $scope.updateRegisteredName();

        let _d = $q.defer();
        SheetLoadedService.wait(_d.promise, 'response-textbox');
        $timeout(() => {
            let ckEditor = CKEDITOR.instances['cke-' + $scope.contentObject.getUUID()];
            if (ckEditor && angular.isFunction(ckEditor.on)) {
                ckEditor.on('instanceReady', (evt) => {
                    _d.resolve('response-textbox');
                });
            } else {
                _d.resolve('response-textbox');
            }
        });

        this.clickOutsideForIframes = (event) => {
            if ($(event.target).closest('body[uuid="' + $scope.contentObject.getUUID() + '"]').length === 0 && $(event.target).find('body[uuid="' + $scope.contentObject.getUUID() + '"]').length === 0) {
                let ckEditor = CKEDITOR.instances['cke-' + $scope.contentObject.getUUID()];
                if (typeof (ckEditor) === 'undefined') {
                    return;
                }
                if (!ckEditor.focusManager.hasFocus) {
                    return;
                }
                ckEditor.focusManager.blur();
                ckEditor.getSelection().removeAllRanges()
            }
        };

        SheetLoadedService
            .getPromise()
            .then(() => {
                $('iframe').contents().find('html').on('click', this.clickOutsideForIframes);
                $('iframe').contents().find('#svgroot').on('click', this.clickOutsideForIframes);
            });

        $scope.onFocus = () => {
            $bridges.runtime().setLastKeyboardLanguage();
        };
    }
}

/**
 * Registers the AsfResponseTextboxObject directive with the given module.
 * @param {Object} module - AngularJS module.
 */
export default function registerAsfResponseTextboxObjectDirective(module) {
    module.directive('asfResponseTextboxObject', function ($compile, $bridges, $config, TaskDataService, $rootScope, $timeout, SheetLoadedService, $q) {
        return {
            restrict: 'EA',
            replace: true,
            scope: {
                "contentObject": "="
            },
            templateUrl: "/views/ib/contentobjects/response-textbox.html",
            controller: AsfResponseTextBoxObjectCtrl
        };
    });

    module.run(['ContentObjectRegistryService', function(ContentObjectRegistryService) {
        let obj = [{
            "uuid": "",
            "content": "",
            "objectType": "response-textbox",
            "type": "contentObject",
            "entity_content": "",
            "preferences": {
                "wordcount": true,
                "height": "170",
                "spellchecker_language": null,
                "spellchecker_is_enabled": false,
                "autogrow": true,
                "richtext": true,
                "placeholder": "",
                "includedInPDF": true,
                "specialChars": null
            }
        }];
        let objProperties = {
            type: "response-textbox",
            isResponse: true,
            label: 'CMS.LAYOUT-MANAGER.NEW-OBJECT.RESPONSE-TEXTBOX.LABEL',
            cssClass: "new-response-textbox-object",
            icon: "cms/icon-response-textbox.png",
            description: 'CMS.LAYOUT-MANAGER.NEW-OBJECT.RESPONSE-TEXTBOX.DESCRIPTION',
            group: {
                id: 1
            }
        };
        ContentObjectRegistryService.register(obj, objProperties);
    }]);
}